<div class="popup-form">
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
        <div *ngIf="currentUserRole.name == 'Super Admin' && userForm.value.role == 'e8921831-15b5-496d-9dcb-f75232ccea08'" class="row">
            <div class="col-md-12 col-12">
              <div class="search-wrap col-md-12 float-right">
                <div class="checkout-wrap">
                  <label class="pager-title">Allow workbench access</label>
                  <div class="checkout margin-bottom-div" >
                    <input class="form-check-input" formControlName="isPreview" type="checkbox" data-testid="adduser-allow-preview-access-input">
                    <div class="checkout-box"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <div>
            <!-- <h6 class="h6-label">User</h6> -->
            <div class="box-wrap">
                <div class="row">
                    <div class="col-sm-6 col-6 input-login">
                        <input type="text" required class="border-input" maxlength="20" formControlName="firstName"
                            (keypress)="keyPress($event)" data-testid="adduser-firstname-input"
                            [ngClass]="{ 'is-invalid': submitted && Usergetter['firstName'].errors }" />
                        <label class="label">First name</label>
                        <div *ngIf="submitted && Usergetter['firstName'].errors" class="invalid-feedback">
                            <!-- <div *ngIf="Usergetter['firstName'].errors['required']" class="invalid-margintop"><span class="txt-error">
                                    Please enter first name</span></div> -->
                        </div>
                    </div>
                    <div class="col-sm-6 col-6 input-login">
                        <input type="text" required class="border-input " maxlength="20" formControlName="lastName"
                            (keypress)="keyPress($event)" data-testid="adduser-lastname-input"
                            [ngClass]="{ 'is-invalid': submitted && Usergetter['lastName'].errors }" />
                        <label class="label">Last name</label>
                        <div *ngIf="submitted && Usergetter['lastName'].errors" class="invalid-feedback">
                            <!-- <div *ngIf="Usergetter['lastName'].errors['required']" class="invalid-margintop"><span class="txt-error">
                                    Please enter last
                                    name</span></div> -->
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6 col-6 input-login date-label">
                        <input type="text" required class="border-input " maxlength="50" formControlName="email"
                        [ngClass]="{ 'is-invalid': submitted && Usergetter['email'].errors }" data-testid="adduser-email-input"
                            [readonly]="isReadonly" placeholder="Expiry Date" (keypress)="keyPress($event)" />
                        <label class="label">Email</label>
                        <div *ngIf="submitted && Usergetter['email'].errors" class="invalid-feedback">
                            <!-- <div *ngIf="Usergetter['email'].errors['required']" class="invalid-margintop txt-error">Email is required
                            </div> -->
                            <!-- <div *ngIf="Usergetter['email'].errors['maxlength']" class="invalid-margintop txt-error">Email maximum
                                length should be 50 characters</div> -->
                            <!-- <div *ngIf="Usergetter['email'].errors['pattern']" class="invalid-margintop txt-error">Please enter valid
                                email address</div> -->
                        </div>
                    </div>
                    <div class="col-sm-6 col-6 input-login">
                        <input type="text" required class="border-input " formControlName="contactNo" data-testid="adduser-contactno-input"
                        mask="+0 (000) 000-0000"  [dropSpecialCharacters]="false" [ngClass]="{ 'is-invalid': submitted && Usergetter['contactNo'].errors }" />
                        <label class="label">Contact no
                            <i class="fa fa-info-circle injury-date popover-icon" placement="top"
                                [ngbPopover]="contactContent" [popoverClass]="isInputFocused ? 'contact-no focused' : 'contact-no'" triggers="mouseenter:mouseleave"></i>
                        </label>
                        <ng-template #contactContent>
                            <div>
                                Enter contact no. with format <br>(e.g. +1 (123) 456-7890)
                            </div>
                        </ng-template>
                        <div *ngIf="submitted && Usergetter['contactNo'].errors" class="invalid-feedback">
                            <!-- <div *ngIf="Usergetter['contactNo'].errors['required']" class="invalid-margintop"><span class="txt-error">
                                    Please enter contact
                                    number</span></div> -->
                            <div *ngIf="Usergetter['contactNo'].errors['minlength']"class="invalid-margintop ">
                                <!-- <span class=" txt-error"> Please enter complete contact number</span> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">

                    <div class="col-sm-6 col-6">
                        <label class="label">Role</label>
                        <select Id="role" class="border-input sel-mat-inp ddl-add-user select" formControlName="role" data-testid="adduser-role-select"
                            [ngClass]="{ 'is-invalid': submitted && Usergetter['role'].errors }"
                            (change)="IsAPIUser($event)" >
                            <option value="" disabled selected class="mrgl45">Select role</option>
                            <option *ngFor="let r of roles" [value]="r.id">
                                {{ r.name }}
                            </option>
                        </select>
                        <div *ngIf="submitted && Usergetter['role'].errors" class="invalid-feedback">
                            <div *ngIf="Usergetter['role'].errors['required']" class="invalid-margintop">
                                <!-- <span class="txt-error">Please select role</span> -->
                            </div>
                        </div>
                    </div>                  
                    <div class="col-md-6 col-6">
                        <mat-label class="font-size-mat-label" >Team</mat-label>
                        <mat-select data-testid="add-user-team-select" id="teamSelect" #selectTeam
                            [ngClass]="{ 'is-invalid': submitted && Usergetter['team'].errors }"
                            panelClass="mat-select-panel-wrap team-select-box" multiple
                            class="sel-mat-inp select border-input val-line" placeholder="Select team" formControlName="team"
                            [value]="selectedTeams" (click)="selectTeam.open()">
                
                            <mat-option class="mat-search-option" id="search-option" disabled>
                                <input id="searchTeamInput" matInput placeholder="Search team" autocomplete="off"
                                    (keyup)="filterTeamInfo($event)" class="mat-select-search-input" />
                            </mat-option>
                
                            <ng-container *ngFor="let team of filterTeam">
                                <mat-option [hidden]="!team.isShow" (click)="toggleOption(team.uiTeamId)"
                                    [value]="team.uiTeamId">
                                    {{ team.stName }}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-12 col-12">
                        <label class="label label-margin-top" >Client</label>
                        <div class="client-label">
                            <label>{{ ViewClienName }}</label>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12 col-12 d-flex pe-0">
                        <div class="row col-12 me-0">
                            <div class="col-sm-12 col-12 d-flex pe-0 margin-bottom-row">
                                <label class="pager-title toggle-label tgl-lbl-width">Allow login</label>
                                <div class="checkout" >
                                    <input class="form-check-input" formControlName="isActive" type="checkbox"  (change)="onToggleChange($event, 'isActive')"
                                        data-testid="addclient-confidence-score-input" [attr.checked]="Usergetter['isActive'].value == 1 ? true : false">
                                    <div class="checkout-box"></div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-12 d-flex pe-0 margin-bottom-row">
                                <label class="pager-title toggle-label tgl-lbl-width">Visible web page
                                     <i  [ngClass]="{ 'd-none': isWebPageToggleEnabled }" class="icon-color fa fa-info-circle injury-date popover-icon" placement="top"
                        [ngbPopover]="teamContent" [popoverClass]="isInputFocused ? 'popover volumePopover widthPopover focused' : 'popover volumePopover widthPopover'" triggers="mouseenter:mouseleave"></i>
                                </label>
                                <ng-template #teamContent>
                         <div class="popover-body"> 
                            Admin has disabled the web page link
                         </div>
                     </ng-template>
                                <div class="checkout" >
                                    <input class="form-check-input" formControlName="isVisibleWebPage" type="checkbox" (change)="onToggleChange($event, 'isVisibleWebPage')"
                                        data-testid="addclient-confidence-score-input" [attr.checked]="Usergetter['isVisibleWebPage'].value == true ? true : false">
                                    <div class="checkout-box"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-12 col-12 div-display-none" #apiAccessToken Id="apiAccessToken">
                        <label class="label mr-3">API access token</label>&nbsp;&nbsp;
                        <button type="button" class="access-tokon-buttons copy-token mr-2" (click)="CopyToken(AccessToken)" data-testid="adduser-token-button">
                            <span aria-hidden="true">
                                <a href="javascript:void(0)">
                                    <i class="fa fa-clipboard fa-sm" placement="right" ngbTooltip="Copy Token"
                                        tooltipClass="ngTooltip"></i>
                                </a>
                            </span>
                        </button>&nbsp;
                        <button type="button" class="access-tokon-buttons" (click)="GenerateTokenWhileAdding()" data-testid="adduser-generate-token-button">
                            <span aria-hidden="true">
                                <a href="javascript:void(0)">
                                    <i class="fa fa-refresh fa-sm" placement="right" ngbTooltip="Generate New Token"
                                        tooltipClass="ngTooltip"></i>
                                </a>
                            </span>
                        </button>
                        <div class="access-token">
                            <label>{{AccessToken}}</label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-12 col-12 right" *ngIf="iscolorvisible > 2">
                        <label class="label">Color Code</label>
                        <input type="color" value="colorCode" (change)="onChangeColor($event)" data-testid="adduser-color-code-input"
                            formControlName="colorCode" class="color-picker-margin input-margin-left" />
                    </div>
                </div>
            </div>
        </div>

        <div class="btn-box pdgtb">
            <button type="submit" class="btn-wrap" data-testid="adduser-submit-input">
                {{buttoncaption}}
            </button>&nbsp;
        </div>

    </form>
</div>